// extracted by mini-css-extract-plugin
export var container = "ManagementBoard-module--container--ad441";
export var fadeInAnimation = "ManagementBoard-module--fadeInAnimation--d3315";
export var wrapper = "ManagementBoard-module--wrapper--4eb64";